<div class="d-flex justify-content-between align-items-center" mat-dialog-title>
    @if (!typeSelected()) {
        <h1 class="condensed dialog-title">Item toevoegen</h1>

    } @else if (typeSelected() && !locationSelected() && addresses()) {
        <h1 class="condensed dialog-title">Adres</h1>

    } @else if ((!addresses() && typeSelected()) || (typeSelected() && locationSelected())) {
        <h1 class="condensed dialog-title">Aan het laden...</h1>
    }
    <div class="dialog-close">
        <div id="btn-cancel" class="fab small active" (click)="onNoClick()">
            <i class="fas fa-times"></i>
        </div>
    </div>
</div>

<div class="dialog-content flex-row" mat-dialog-content>
    <div class="d-flex w-100">
        @if (!typeSelected()) {
            @if (checking()) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            } @else {
                <ng-container class="d-flex">
                    <button (click)="selectType(false)" id="btn-create-figuration" mat-stroked-button tabindex="-1">
                        <i class="fas fa-bicycle fa-4x pt-2"></i><br>
                        Figuratie
                    </button>
                    <button (click)="selectType(true)" id="btn-create-lengthmark" mat-stroked-button tabindex="-1">
                        <i class="fas fa-road fa-4x pt-2"></i><br>
                        Lengtemarkering
                    </button>
                    @if (this.AuthorisationService.hasFeature('extraCostSave') && showExtraCostsButton()) {
                        <button (click)="otherType('extraCost')" class="ms-0" id="btn-add-extra-cost" mat-stroked-button tabindex="-1">
                            <i class="fas fa-euro-sign fa-4x pt-2"></i><br>
                            Extra kosten
                        </button>
                    }
                    @if (this.AuthorisationService.hasFeature('saveTailCharges') && showExtraCostsButton()) {
                        <button (click)="otherType('tailCharge')" class="ms-0" id="btn-add-tail-charge" mat-stroked-button tabindex="-1">
                            <i class="fas fa-percent fa-4x pt-2"></i><br>
                            Staartkosten
                        </button>
                    }
                </ng-container>
            }
        }
        @if (typeSelected() && !locationSelected() && addresses()) {
            @if (typeSelected()) {
                <table class="table table-hover curpoint" id="adress-table">
                    @for (address of addresses(); track address) {
                        <tr (click)="select(address)">
                            <td>
                                {{address.address.addressLine}}
                                <br> {{address.address.postalCode}} {{address.address.adminDistrict2}}
                            </td>
                        </tr>
                    }
                </table>
            }
        }
        @if ((!addresses() && typeSelected()) || (typeSelected() && locationSelected())) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
    </div>
</div>
